var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { loginRouterList } from "./config";
import "./mainLayout.less";
var LoginLayout = /** @class */ (function (_super) {
    __extends(LoginLayout, _super);
    function LoginLayout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoginLayout.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "login-banner" }),
            React.createElement("div", { className: "sms-one" }),
            React.createElement(Switch, null,
                loginRouterList.map(function (config) { return (React.createElement(Route, { exact: true, key: config.path, path: config.path, component: config.component, title: config.title })); }),
                React.createElement(Route, { component: function () { return React.createElement(Redirect, { to: "/account/login" }); } }))));
    };
    return LoginLayout;
}(React.Component));
export default LoginLayout;
